const YOUTUBE_HOSTS = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com'];
const SHORT_LINK_HOSTS = ['youtu.be', 'www.youtu.be'];
const VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;
const ID_IN_PATH_PREFIXES = ['embed', 'shorts', 'live', 'v'];

export function extractYouTubeVideoId(url) {
  let parsed;
  try {
    parsed = new URL((url || '').trim());
  } catch (e) {
    return null;
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return null;
  }

  const host = parsed.hostname.toLowerCase();
  const segments = parsed.pathname.split('/').filter(Boolean);
  let candidate = '';
  if (SHORT_LINK_HOSTS.includes(host)) {
    [candidate = ''] = segments;
  } else if (!YOUTUBE_HOSTS.includes(host)) {
    return null;
  } else if (segments.length === 1 && segments[0] === 'watch') {
    candidate = parsed.searchParams.get('v') || '';
  } else if (segments.length >= 2 && ID_IN_PATH_PREFIXES.includes(segments[0])) {
    [, candidate] = segments;
  }
  return VIDEO_ID_PATTERN.test(candidate) ? candidate : null;
}

export function youTubeEmbedUrl(videoId) {
  const origin = encodeURIComponent(window.location.origin);
  return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&enablejsapi=1&origin=${origin}`;
}
